module.exports = __webpack_public_path__ + "static/media/timeline-2.5957ed1c.png";